import styled from 'styled-components';
import theme from '../../styles/theme';

export const TabWrapper = styled.div`
  display: flex;

  & > button {
    width: 100%;
    height: 50px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: ${theme.color.policyGrey};
    border-bottom: 2px solid transparent;
    -webkit-tap-highlight-color: transparent;

    &.active {
      border-bottom: 2px solid ${theme.color.blue};
      background-color: ${theme.backgroundColor.white};
      color: ${theme.color.blue};
      -webkit-transition-duration: 0.25s; /* Safari, Chrome */
      transition-duration: 0.25s;
    }
  }
`;
